import type { RatingSortingInput } from '@packages/gql/generated/shopping/graphql';

export const enum CustomerReviewsSort {
  NEWEST = 'newest',
  OLDEST = 'oldest',
  BEST = 'best',
  WORST = 'worst',
}
export type CustomerReviewsSortParams = CustomerReviewsSort | string | undefined;

export const getSortParams = (sortBy: CustomerReviewsSortParams): RatingSortingInput => {
  switch (sortBy) {
    case CustomerReviewsSort.OLDEST: {
      return {
        field: 'DATE',
        order: 'ASC',
      };
    }
    case CustomerReviewsSort.BEST: {
      return {
        field: 'STARS',
        order: 'DESC',
      };
    }
    case CustomerReviewsSort.WORST: {
      return {
        field: 'STARS',
        order: 'ASC',
      };
    }
    case CustomerReviewsSort.NEWEST:
    default: {
      return {
        field: 'DATE',
        order: 'DESC',
      };
    }
  }
};
